import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import * as Yup from "yup";

import { useLoginService } from "../services/useLoginService";

export type LoginFormValues = {
	email: string;
	password: string;
	remember?: boolean;
};

export const useLoginForm = () => {
	const { translate } = useLocales();

	const { isLoading, loginService, errorMessage } = useLoginService();

	const LoginSchema = Yup.object().shape({
		email: Yup.string()
			.email(translate("login.email_must_be_valid"))
			.required(translate("login.email_required")),
		password: Yup.string().required(translate("login.password_required")),
		remember: Yup.boolean()
	});

	const defaultValues = {
		email: "",
		password: "",
		remember: true
	};

	const methods = useForm<LoginFormValues>({
		resolver: yupResolver(LoginSchema),
		defaultValues
	});

	const onSubmit = async (data: LoginFormValues) => {
		loginService(data);
	};

	return {
		methods,
		isLoading,
		onSubmit: methods.handleSubmit(onSubmit),
		errorMessage
	};
};
